import { I18N_NS } from "Config/i18n";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { oxLinksMap } from "Pages/Project/OxIntegration/subMenuConfig";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getUrlParams } from "utils/getUrlParams";
import { notificationError } from "utils/libHelpers/AntdNotification";

export const OXAuthentication = () => {
  const { t } = useTranslation(I18N_NS.LOGIN);
  const location = useLocation();
  const navigate = useNavigate();

  const requestConnectOX = async () => {
    try {
      const params = getUrlParams(location.search);
      const formData: API_Oauth2RedirectData = {
        code: params?.code,
        state: params?.state,
        error: params?.error,
        error_description: params?.error_description,
        samlResponse: params?.SAMLResponse || params?.samlResponse || params?.samlresponse || params?.saml_response,
      };
      const response = await API.newData<API_OxConnectionResult>(API_URL.OX.connect(), formData);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const spaUrl: string = `/project/${response.project}/constructions/${oxLinksMap[response.module]}/${
        response.entryId
      }`;
      navigate(spaUrl, { state: { data: response } });
    } catch (error) {
      notificationError(t("Error"), t("Failed to connect to OX"));
      navigate("/dashboard");
      throw error;
    }
  };

  React.useEffect(() => {
    requestConnectOX();
  }, []);

  return null;
};
